export const reactQuickstartContent = `# React Quickstart

## 1) Install

\`\`\`bash
npm i lightswitch-js
\`\`\`

## 2) Wrap your app

\`\`\`tsx
// App.tsx
import { LightswitchProvider } from "lightswitch-js";
import { supabase } from "@/integrations/supabase/client";

export default function AppRoot() {
  return (
    <LightswitchProvider
      publishableKey="pk_flow-state-app"
      appSlug="flow-state-app"
      supabaseClient={supabase}
      autoShowPaywall={true}  // auto show paywall if not entitled
    >
      {/* your routes/components */}
    </LightswitchProvider>
  );
}
\`\`\`

## 3) Wire up auth buttons

\`\`\`tsx
import { useLightswitchAuth } from "lightswitch-js";

export function AuthButtons() {
  const { handleLightswitchSignIn, handleLightswitchSignUp } = useLightswitchAuth();

  return (
    <>
      <Button onClick={() => handleLightswitchSignIn("/app")}>Sign In</Button>
      <Button onClick={() => handleLightswitchSignUp("/app")}>Start Your Flow</Button>
    </>
  );
}
\`\`\`

## 4) Protect paid areas

\`\`\`tsx
import { ProtectedRoute } from "lightswitch-js";

export default function PaidDashboard() {
  return (
    <ProtectedRoute>
      {/* Only renders if user is entitled; otherwise paywall appears */}
      <Dashboard />
    </ProtectedRoute>
  );
}
\`\`\`

That's it. Your users can sign in/up, pay (if configured), and immediately access protected content.`;
